import type {
  ParticipantBehaviour,
  ParticipantEmbeddableForm,
  ParticipantQr,
} from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ParticipantQRDeleteModal } from './ParticipantQRDeleteModal';
import { ParticipantQREditModal } from './ParticipantQREditModal';

interface Props {
  isDisabled?: boolean;
  qr: ParticipantQr;
  participantBehaviours: ParticipantBehaviour[];
  participantId: string;
  participantEmbeddableForms: ParticipantEmbeddableForm[];
}

export const ParticipantQRActionsMenu = (props: Props) => {
  const {
    isDisabled,
    qr,
    participantBehaviours,
    participantId,
    participantEmbeddableForms,
    ...rest
  } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='plain' size='sm' disabled={isDisabled} {...rest}>
          Actions
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantQREditModal, {
                participantId,
                participantBehaviours,
                participantEmbeddableForms,
                qr,
              })
            }
            disabled={isDisabled}
            value='edit'
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantQRDeleteModal, {
                participantId,
                qrId: qr.id,
                qrName: qr.name,
              })
            }
            color='danger'
            value='delete'
            disabled={isDisabled}
          >
            <FaRegTrashAlt />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
